import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const useResponsive = (size) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(size));
};

export default useResponsive;
